import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { ReactComponent as AlysSvgLight } from "assets/images/logos/alys_logo_light.svg";
import { ReactComponent as AlysSvgDark } from "assets/images/logos/alys_logo_dark.svg";

const AlysIcon = ({ active, ...props }) => (
  <SvgIcon {...props}>{active ? <AlysSvgDark /> : <AlysSvgLight />}</SvgIcon>
);

export default AlysIcon;
